import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Security'));

function LoadableSecurity() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableSecurity;
